var app = angular.module("DSShopify");
app.filter("changePricing", function () {
  return function (price) {
    var price = addDecimal(price);
    function addDecimal(number) {
      let arr = String(number).split("");
      let reqIndex = arr.length - 2;
      arr.splice(reqIndex, 0, ".");
      return parseFloat(arr.join("")).toFixed(2);
    }
    return price;
  };
});
app.controller("EnrollmentCtrl", [
  "$window",
  "$scope",
  "$rootScope",
  "$uibModal",
  "sideBarService",
  "$templateCache",
  "calculateService",
  "$timeout",
  function (
    $window,
    $scope,
    $rootScope,
    $uibModal,
    sideBarService,
    $templateCache,
    calculateService,
    $timeout
  ) {
    $scope.calculateService = calculateService;
    $scope.cart = theme.dzStrings.cart;

    function updateThemeCart() {
      $.getJSON("/cart.js", function(cart) {
        theme.dzStrings.cart = cart; // Update the theme cart object
        $scope.updateCart(); // Update the scope
      });
    }

        // Function to update cart in the scope
    $scope.updateCart = function () {
      $timeout(function () {
        $scope.cart = theme.dzStrings.cart;
        console.log("Cart should be updated...", $scope.cart);
      });
    };

    // Call updateThemeCart after any cart modification
    function fetchUpdatedCartData() {
      updateThemeCart(); // Fetch and update cart data
    }
    
    $scope.enrollment = $scope.enrollment || JSON.parse(sessionStorage.getItem('EnrollmentFormData')) || {};
    $scope.enrollment.personalInfo = $scope.enrollment.personalInfo || {};
    $scope.enrollment.shippingAddress = $scope.enrollment.shippingAddress || {};
    $scope.enrollment.mailingAddress = $scope.enrollment.mailingAddress || {};
    $scope.enrollment.shippingAddress.Check = 1;

    $rootScope.EnrollmentPack = $rootScope.EnrollmentPack || JSON.parse(localStorage.getItem("cart.packs")) || [];
    $rootScope.AutoshipItems = $rootScope.AutoshipItems || JSON.parse(localStorage.getItem("cart.autoship")) || [];
    $rootScope.BundlePack = $rootScope.BundlePack || JSON.parse(localStorage.getItem("cart.bundle")) || [];

    /* ============================================================
       ENROLLMENT ELIGIBILITY — EUROPE
       Replaces the whole previous eligibility block: everything from
       the old  /* === ENROLLMENT ELIGIBILITY === *​/  comment down to
       and including  $scope.computeEnrollmentEligibility();

       Enrolment now requires ONLY the enrolment kit (SKU 80065).
       Starter sets are ordinary products. The build-your-own total is
       tracked purely to show progress toward the 30% discount and
       never blocks checkout.
       ============================================================ */

    /* Product spend that unlocks the build-your-own discount.
       Per store:  USD 300   CAD 415   EUR 315 */
    const ENROLLMENT_PRODUCT_TARGETS = {
      EUR: 315,
    };

    const CURRENCY_SYMBOLS = {
      EUR: '€',
    };

    /* The enrolment kit / registration fee. Its presence in the cart is
       the ONLY requirement to enrol. Same SKU on every storefront. */
    const ENROLLMENT_FEE_SKUS = new Set(['80065']);

    /* Variant id of that kit ON THIS STORE — it differs per storefront.
       Detection is by SKU, so leaving this null still gates correctly;
       it only hides the "add it for me" button. */
    const ENROLLMENT_FEE_VARIANT_ID = null;

    /* Discount earned on individual products once the target is reached.
       Display only — the discount itself is applied elsewhere. */
    const ENROLLMENT_BUNDLE_DISCOUNT = 30;

    /* Products that are bundles/kits/fees — never count toward the
       build-your-own total. */
    const EXCLUDED_SKUS_BUNDLE = new Set([
      '80065', '80068', '80066', '80067', '80069', '80070', '80071', '80072', '80073',
      '55032OB', 'ORBOX', '43938', '55023', '70098', '70097', '70096', '55022',
      '55020', '55021', '55024', '55025', '55026', '55036', '55038', '55039',
      '80002', '80017', '80025', '52225', '80057', '80058', '80056', '50000',
      '51127', '52228', '40056', '40057', '40058', '40059', '70045', '70044',
      '80010', '80078', '80001', '80000', '51106SOB', '51109GIFT',
      'OTPC_REGISTRATION',
      '25GIFTCARD', '50GIFTCARD', '75GIFTCARD', '100GIFTCARD', '150GIFTCARD',
      '200GIFTCARD', '250GIFTCARD', '300GIFTCARD', '350GIFTCARD',
      '55014OB', '55101', '55102', '55103', '55104',
    ]);

    /* Title of the automatic discount that fires once the target is met.
       Its presence proves the customer already qualified. */
    const BUNDLE_DISCOUNT_TITLE_MATCH = /starter kit enrollment/i;

    function normaliseSku(item) {
      return String((item && item.sku) || '').trim().toUpperCase();
    }

    /* Progress must be measured BEFORE line discounts. Once the 30% fires
       the discounted totals drop back under the target, which would flip
       a qualifying cart back under and cancel the discount. */
    function enrollmentOriginalLineTotal(item) {
      if (typeof item.original_line_price === 'number') return item.original_line_price;
      if (typeof item.line_price === 'number') return item.line_price;
      if (typeof item.original_price === 'number') {
        return item.original_price * (Number(item.quantity) || 1);
      }
      return (Number(item.price) || 0) * (Number(item.quantity) || 1);
    }

    function hasBundleDiscount(item) {
      const discounts = item.discounts
        || item.line_level_discount_allocations
        || [];
      return discounts.some(function (discount) {
        const title = (discount && (discount.title
          || (discount.discount_application && discount.discount_application.title))) || '';
        return BUNDLE_DISCOUNT_TITLE_MATCH.test(title);
      });
    }

    $scope.eligibility = {
      ready: false,
      eligible: false,       // kit in cart — the only enrolment requirement
      feeInCart: false,
      feeVariantId: ENROLLMENT_FEE_VARIANT_ID,
      discountReached: false,
      qualifying: 0,         // cents, products only
      productTarget: 0,      // cents, spend that unlocks the discount
      remaining: 0,          // cents
      percent: 0,
      excludedCount: 0,
      discountPercent: ENROLLMENT_BUNDLE_DISCOUNT,
      discountActive: false,
      currency: 'EUR',
      symbol: '€',
    };

    /* Adds the enrolment kit for the customer. Reuses the controller's own
       add-to-cart path so the cart refresh behaves identically. */
    $scope.addEnrollmentKit = function () {
      if (!ENROLLMENT_FEE_VARIANT_ID) return;
      $scope._addKitToCart(ENROLLMENT_FEE_VARIANT_ID, 'enrollment-kit');
    };

    $scope.computeEnrollmentEligibility = function () {
      const items = ($rootScope.BundlePack || []).filter(Boolean);

      const currency = (($scope.cart && $scope.cart.currency) || 'EUR')
        .toString().trim().toUpperCase();
      const productTarget =
        (ENROLLMENT_PRODUCT_TARGETS[currency] || ENROLLMENT_PRODUCT_TARGETS.EUR) * 100;

      let qualifying = 0;
      let excludedCount = 0;
      let discountActive = false;
      let feeInCart = false;

      items.forEach(function (item) {
        const sku = normaliseSku(item);

        /* The kit never counts toward the product total, but its presence
           is what makes the cart eligible to enrol. */
        if (ENROLLMENT_FEE_SKUS.has(sku)) {
          feeInCart = true;
          return;
        }

        if (EXCLUDED_SKUS_BUNDLE.has(sku)) {
          excludedCount += 1;
          return;
        }

        if (hasBundleDiscount(item)) {
          discountActive = true;
        }

        qualifying += enrollmentOriginalLineTotal(item);
      });

      /* An active line discount proves the cart already qualified, so it
         stands even if the arithmetic disagrees. */
      const eligible = feeInCart;
      const discountReached = discountActive
        || (productTarget > 0 && qualifying >= productTarget);

      $scope.eligibility = {
        ready: true,
        eligible: eligible,
        feeInCart: feeInCart,
        feeVariantId: ENROLLMENT_FEE_VARIANT_ID,
        discountReached: discountReached,
        qualifying: qualifying,
        productTarget: productTarget,
        remaining: Math.max(productTarget - qualifying, 0),
        percent: productTarget > 0
          ? Math.min(Math.round((qualifying / productTarget) * 100), 100)
          : 100,
        excludedCount: excludedCount,
        discountPercent: ENROLLMENT_BUNDLE_DISCOUNT,
        discountActive: discountActive,
        currency: currency,
        symbol: CURRENCY_SYMBOLS[currency] || '€',
      };
    };

    /* Recompute on every cart mutation. angular.toJson catches inline
       quantity edits as well as the wholesale reassignment in
       getBundleItems(). */
    $scope.$watch(
      function () { return angular.toJson($rootScope.BundlePack); },
      function () { $scope.computeEnrollmentEligibility(); }
    );

    $scope.computeEnrollmentEligibility();

    $scope.enrollment.mailingAddress.State = $scope.enrollment.mailingAddress.State || "UT";
    $scope.payment = {};
    $scope.onLastSection = false;
    $scope.enrollment.personalInfo.birthMonth = handleNumberNormalization($scope.enrollment.personalInfo.birthMonth) || "01";
    $scope.enrollment.personalInfo.birthDay = handleNumberNormalization($scope.enrollment.personalInfo.birthDay) || "01";
    $scope.enrollment.personalInfo.birthYear = handleNumberNormalization($scope.enrollment.personalInfo.birthYear) || "2000";

    $scope.isPhoneChecked = false;
    $scope.isEmailChecked = false;
    $scope.isUsernameChecked = false;

    $scope.availableStates = [];
    $rootScope.hideLoader();
    $scope.DefaultEnrollKit = {};
    $scope.isEnrollmentJoinPage = false;
    $scope.isEmailVerifying = false;
    $scope.isUsernameVerifying = false;

    $scope.detectCurrentEnrollment = function () {
      if (window.location.pathname.includes('enrollment-join')) {
        $scope.isEnrollmentJoinPage = true;
      }
    };
    $scope.detectCurrentEnrollment();

    function handleNumberNormalization(number) {
      try {
        if (parseInt(number, 10) > 0) {
          if (number.toString().length > 1)
            return number.toString();
          else {
            return `0${number.toString()}`;
          }
        }
      } catch (error) { }
    }

    $scope.starterKitQuantity = {
      "facial-glow-starter-set": 1,
      "healing-olive-facial-glow": 1,
      "holistic-beauty-inside-and-out-starter-set": 1,
      "glow-from-the-inside-out-starter-set": 1
    };

    $scope.GetStates = function () {
      let countryCode = 'US';
      window.DI.Enrollment.GetStates(countryCode).then((response) => {
        if (response.Data && response.Status == 1) {
          $rootScope.hideLoader();
          $scope.availableStates = response.Data;
          if (!$scope.enrollment.mailingAddress.State) {
            $scope.enrollment.mailingAddress.State = $scope.availableStates[0].StateCode;
          }
          $scope.$apply();
        }
        console.log(response);
      }).catch(() => $rootScope.hideLoader());
    };

    $scope.UpdateToNextStep = function (panelNumber) {
      // closing current accordion
      $(`.accordion-panel-${panelNumber - 1}`).next().slideToggle(200);
      $(`.accordion-panel-${panelNumber - 1}`).removeClass('open', 200);
      $(`.accordion-panel-${panelNumber - 1}`).css('pointer-events', 'auto');

      // opening next accordion
      $(`.accordion-panel-${panelNumber}`).next().css('display', 'block');
      $(`.accordion-panel-${panelNumber}`).addClass('open', 200);

      if (panelNumber == 3) {
        $(`.accordion-panel-${panelNumber}`).css('pointer-events', 'auto');
      }

      if (!$scope.isEnrollmentJoinPage) {
        // $scope.handlePlaceOrderButton()
      }
    };

    $scope._openFirstPanel = function () {
      $(`.accordion-panel-1`).next().slideDown(200);
      $(`.accordion-panel-1`).addClass('open', 200);
      $(`.accordion-panel-2`).next().slideUp(200);
      $(`.accordion-panel-2`).removeClass('open', 200);
      $(`.accordion-panel-2`).css('pointer-events', 'none');
      $(`.accordion-panel-3`).next().slideUp(200);
      $(`.accordion-panel-3`).removeClass('open', 200);
      $(`.accordion-panel-3`).css('pointer-events', 'none');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    jQuery(function ($) {
      $('.js-accordion-title').on('click', function () {
        $(this).next().slideToggle(200);
        $(this).toggleClass('open', 200);
      });

      var icons = document.querySelectorAll(".header__icon-touch");
      icons.forEach((icon) => {
        if (icon.getAttribute("data-js-cart-icon") == "") {
          icon.style.display = "none";
        }
      });
    });

    $scope.handlePlaceOrderButton = function () {
      if ($('.accordion-panel-3').hasClass('open')) {
        $scope.onLastSection = true;
      } else {
        $scope.onLastSection = false;
      }
      $scope.$apply();
    };

    window.addEventListener('beforeunload', (event) => {
      $scope.enrollment.personalInfo.Email = "";
      $scope.enrollment.personalInfo.ConfirmEmail = "";
      $scope.enrollment.webOffice = {};
      $scope.enrollment.mailingAddress.Contact = "";
      sessionStorage.setItem('EnrollmentFormData', JSON.stringify($scope.enrollment));
    });

    if (Number($scope.enrollment.shippingAddress.Check) === 1) { }

    $scope.navigateToProduct = function () { };

    $scope.GetShipName = function (handle) {
      console.log('selected shipping', $scope.enrollment.selectedShippingMethod);
      console.log("GetShipName");
      $scope.calculateShippingTotal();
    };

    $scope.ClearApplication = function (element) {
      var id = "#" + element.target.id;
      if ($(id).is(":checked")) {
        $(id).closest(".control-group").find(".has-error.help-block").remove();
        $(id).closest(".control-group").removeClass("has-error");
      }
    };

    $scope.verifyUsername = async function () {
      if ($scope.enrollment.webOffice.UserName) {
        $rootScope.showLoader();
        $scope.isUsernameVerifying = true;
        await window.DI.Enrollment.verifyusername($scope.enrollment.webOffice.UserName).then(function (response, error) {
          console.log("Verify Username", response, error);
          if (response && response.Status == 1) {
            if (response.Data) {
              $scope.isUsernameChecked = true;
            } else {
              $scope.enrollment.webOffice.UserName = "";
              window.DI.DI.notification("Error", "UserName Not Available", "error");
              $scope.isUsernameChecked = false;
            }
          } else {
            $scope.enrollment.webOffice.UserName = "";
            window.DI.DI.notification("Error", "UserName Not Available", "error");
            $scope.isUsernameChecked = false;
          }
          $scope.isUsernameVerifying = false;
          $rootScope.hideLoader();
          return response;
        }).catch((error) => {
          $scope.isUsernameChecked = false;
          $scope.isUsernameVerifying = false;
          $rootScope.hideLoader();
        });
        $scope.$apply();
      }
    };

    $scope.verifyEmailExists = async function (isLoading) {
      var filter = new RegExp("^([\\w-\\.+]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([\\w-]+\\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\\]?)$");
      if ($scope.enrollment.personalInfo.Email && filter.test($scope.enrollment.personalInfo.Email)) {
        if (isLoading) $rootScope.showLoader();
        $scope.isEmailVerifying = true;
        let request = {
          "email": $scope.enrollment.personalInfo.Email
        };

        await window.DI.Enrollment.verifyusernameAndemail(request).then(function (response, error) {
          console.log("Full API response: V1", response);
          if (response && response.Status) {
            if (response.Data) {
              $scope.isEmailChecked = true;
            } else {
              $scope.enrollment.personalInfo.Email = "";
               $scope.enrollment.personalInfo.ConfirmEmail = "";
              window.DI.DI.notification("Error", "email is already in use", "error");
              $scope.isEmailChecked = false;
            }
          } else {
            $scope.enrollment.personalInfo.Email = "";
            $scope.enrollment.personalInfo.ConfirmEmail = "";
            window.DI.DI.notification("Error", "email is already in use", "error");
            $scope.isEmailChecked = false;
          }
          if (isLoading) $rootScope.hideLoader();
          $scope.isEmailVerifying = false;
          return response;
        }).catch(() => {
          if (isLoading) $rootScope.hideLoader();
          $scope.isEmailChecked = false;
          $scope.isEmailVerifying = false;
        });
        $scope.$apply();
      }
    };
$scope.VerifyPhoneExists = function () {
  var raw = ($scope.enrollment.mailingAddress.Contact || '').trim();
  if (!raw) return;

  raw = raw.replace(/[^0-9+\s-]/g, '');
  $scope.enrollment.mailingAddress.Contact = raw;

  if (raw.length > 18) {
    raw = raw.slice(0, 18);
    $scope.enrollment.mailingAddress.Contact = raw;
  }

  var cleaned = raw;
  if (cleaned.startsWith('00')) cleaned = '+' + cleaned.slice(2);

  if (cleaned.indexOf('+') > 0) {
    window.DI.DI.notification("Error", "Invalid phone number format", "error");
    $scope.isPhoneChecked = false;
    return;
  }

  var digitsOnly = cleaned.replace(/\D/g, '');
  var count = digitsOnly.length;

  if (count < 8 || count > 15) {
    window.DI.DI.notification("Error", "Enter a valid phone number (8–15 digits)", "error");
    $scope.isPhoneChecked = false;
    return;
  }

  $rootScope.showLoader();
  $scope.isPhoneChecked = false;

  try {
    var ret = window.DI.Enrollment.VerifyPhoneExists(cleaned);

    // promise-safe: only use .then if it exists
    if (ret && typeof ret.then === "function") {
      ret.then(function (response) {
        console.log("VerifyPhoneExists", response);

        if (response && response.Status) {
          if (response.Data) {
            window.DI.DI.notification("Success", "Phone Available", "success");
            $scope.isPhoneChecked = true;
          } else {
            $scope.enrollment.mailingAddress.Contact = "";
            window.DI.DI.notification("Error", "This phone number is already used", "error");
            $scope.isPhoneChecked = false;
          }
        } else {
          $scope.enrollment.mailingAddress.Contact = "";
          window.DI.DI.notification("Error", "Phone number not available", "error");
          $scope.isPhoneChecked = false;
        }

        $rootScope.hideLoader();
        ($scope.$applyAsync && $scope.$applyAsync()) || $scope.$apply();
      }, function (err) {
        console.error("VerifyPhoneExists error", err);
        window.DI.DI.notification("Error", "Could not verify phone right now", "error");
        $scope.isPhoneChecked = false;

        $rootScope.hideLoader();
        ($scope.$applyAsync && $scope.$applyAsync()) || $scope.$apply();
      });

      return;
    }

    // unexpected return type
    window.DI.DI.notification("Error", "Could not verify phone right now", "error");
    $scope.isPhoneChecked = false;
    $rootScope.hideLoader();
  } catch (err) {
    console.error("VerifyPhoneExists exception", err);
    window.DI.DI.notification("Error", "Could not verify phone right now", "error");
    $scope.isPhoneChecked = false;
    $rootScope.hideLoader();
  }
};




// Helper: returns [customersArray, isEmailAvailableBool]
function verifyEmailAndCustomerType(emailAddress) {
  const customerData = new Promise((resolve) => {
    try {
      window.DI.Enrollment.GetCustomerInfoByEmail(emailAddress).then(
        (response) => {
          // Data can be null -> normalize to []
          const data = response && response.Data;

          if (Array.isArray(data)) return resolve(data);
          if (data && typeof data === "object") return resolve([data]); // just in case API returns a single object
          return resolve([]); // null/undefined => no customer
        },
        () => resolve([]) // failure path
      );
    } catch (e) {
      resolve([]);
    }
  });

  const isEmailAvailable = new Promise((resolve) => {
    try {
      window.DI.Enrollment.verifyusernameAndemail({ email: emailAddress }).then(
        (response) => resolve(!!(response && response.Data)), // USA: truthy Data
        () => resolve(false)
      );
    } catch (e) {
      resolve(false);
    }
  });

  return Promise.all([customerData, isEmailAvailable]);
}







$scope.verifyEmailAndCustomerType = function (isLoading = false) {
  var filter = new RegExp("^([\\w-\\.+]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([\\w-]+\\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\\]?)$");
  const email = ($scope.enrollment.personalInfo.Email || "").trim();
  if (!email || !filter.test(email)) return;

  if (isLoading) $rootScope.showLoader();
  $scope.isEmailVerifying = true;

  verifyEmailAndCustomerType(email).then(
    ([customers, isEmailAvailable]) => {
      customers = Array.isArray(customers) ? customers : [];

      // ✅ email is available (no account exists in DS)
      if (isEmailAvailable === true && !customers.length) {
        window.DI.DI.notification("Success", "Email Available", "success");
        $scope.isEmailChecked = true;
      }
      // ✅ allow all accounts WITHOUT CustomerType: 1
      else if (!customers.some(item => item && item.CustomerType === 1)) {
        window.DI.DI.notification("Success", "Email Available", "success");
        $scope.isEmailChecked = true;
      }
      // ❌ disallow CustomerType: 1
      else {
        $scope.enrollment.personalInfo.Email = "";
        $scope.enrollment.personalInfo.ConfirmEmail = "";
        window.DI.DI.notification("Error", "Email is already in use", "error");
        $scope.isEmailChecked = false;
      }

      if (isLoading) $rootScope.hideLoader();
      $scope.isEmailVerifying = false;
      ($scope.$applyAsync && $scope.$applyAsync()) || $scope.$apply();
    },
    () => {
      if (isLoading) $rootScope.hideLoader();
      $scope.isEmailChecked = false;
      $scope.isEmailVerifying = false;
      window.DI.DI.notification("Error", "Could not verify email right now", "error");
      ($scope.$applyAsync && $scope.$applyAsync()) || $scope.$apply();
    }
  );
};










// === EU Country → Region wiring (SANITIZED + PROMISE-SAFE DROP-IN) ===
// Place this AFTER you create $scope.enrollment and $scope.enrollment.mailingAddress

// Safety: ensure objects exist
$scope.enrollment = $scope.enrollment || {};
$scope.enrollment.mailingAddress = $scope.enrollment.mailingAddress || {};
$scope.eu = $scope.eu || { regionsByCountry: {}, regions: [] };
$scope.isRegionsLoading = false;

// Friendly name → ISO2 (extend as needed)
var COUNTRY_TO_ISO2 = {
  'Germany':'DE','Austria':'AT','Switzerland':'CH','France':'FR','Spain':'ES','Italy':'IT',
  'Belgium':'BE','Netherlands':'NL','Luxembourg':'LU','Poland':'PL',
  'United Kingdom':'GB','UK':'GB','Denmark':'DK','Norway':'NO','Sweden':'SE'
};

// ---- Helpers ----

// Replace invalid JSON tokens & trailing commas BEFORE parsing
function sanitizeJsonText(txt) {
  if (!txt) return txt;
  var cleaned = txt.replace(/^\uFEFF/, '');       // strip BOM
  cleaned = cleaned.replace(/\bNaN\b/g, 'null')
                   .replace(/\bInfinity\b/g, 'null')
                   .replace(/\b-Infinity\b/g, 'null');
  // remove trailing commas before } or ]
  cleaned = cleaned.replace(/,(\s*[}\]])/g, '$1');
  return cleaned;
}

function readEuJson() {
  var el = document.getElementById('eu-regions');
  if (!el) {
    console.warn('[EU] #eu-regions script tag not found.');
    return {};
  }

  var raw = el.textContent || el.innerText || '';
  var data = {};
  try {
    data = JSON.parse(raw || '{}');
  } catch (e1) {
    console.warn('[EU] Raw JSON parse failed; sanitizing…', e1);
    try {
      data = JSON.parse(sanitizeJsonText(raw) || '{}');
    } catch (e2) {
      console.error('[EU] Sanitized JSON still failed:', e2);
      return {};
    }
  }

  // Mirror ISO2 onto friendly names (so "Germany" works if only "DE" exists)
  Object.keys(COUNTRY_TO_ISO2).forEach(function (friendly) {
    var iso = COUNTRY_TO_ISO2[friendly];
    if (data[iso] && !data[friendly]) data[friendly] = data[iso];
  });
  // Mirror UPPERCASE keys too (so 'de' model works)
  Object.keys(data).forEach(function (k) {
    var up = String(k).toUpperCase();
    if (!data[up]) data[up] = data[k];
  });

  return data;
}

// Normalize any list into [{code,name}]
function normalizeRegions(list) {
  if (!Array.isArray(list) || !list.length) return [];
  var first = list[0];

  // Already objects with code/name
  if (first && typeof first === 'object' && ('code' in first || 'name' in first)) {
    return list.map(function (r) {
      return { code: String(r.code || r.name || ''), name: String(r.name || r.code || '') };
    }).filter(function (r) { return r.code && r.name; });
  }
  // Legacy string array
  if (typeof first === 'string') {
    return list.map(function (n) { return { code: String(n), name: String(n) }; });
  }
  console.warn('[EU] Unexpected region item shape:', first);
  return [];
}

// Find the best key inside regionsByCountry for a given country value
function resolveCountryKey(countryVal, regionsByCountry) {
  if (!countryVal) return '';
  if (regionsByCountry[countryVal]) return countryVal;               // exact
  var up = String(countryVal).toUpperCase();
  if (regionsByCountry[up]) return up;                               // uppercase
  var iso = COUNTRY_TO_ISO2[countryVal];
  if (iso && regionsByCountry[iso]) return iso;                      // friendly → ISO2
  return '';                                                         // no match
}

// Coerce anything into a thenable without using .catch/.finally
function asThenable(x) {
  if (x && typeof x.then === 'function') return x;
  if (window.angular && angular.injector) {
    try {
      var $q = angular.element(document.body).injector().get('$q');
      return $q.when(x);
    } catch (e) { /* fall through */ }
  }
  // Minimal native Promise fallback
  return new Promise(function (resolve) { resolve(x); });
}

// ---- API fallback ----
$scope.fetchRegionsFromAPI = function (iso2) {
  if (!iso2 || iso2.length !== 2) {
    console.warn('[EU] fetchRegionsFromAPI skipped: invalid iso2:', iso2);
    return asThenable();
  }
  console.log('[EU] fetchRegionsFromAPI start. ISO:', iso2);
  $scope.isRegionsLoading = true;

  var p = (window.DI && window.DI.Enrollment && window.DI.Enrollment.GetStates)
    ? window.DI.Enrollment.GetStates(iso2)
    : null;

  if (!p) {
    console.warn('[EU] GetStates API unavailable; cannot fetch regions for', iso2);
    $scope.isRegionsLoading = false;
    return asThenable();
  }

  return asThenable(p).then(function (resp) {
    console.log('[EU] API GetStates response:', resp);

    var mapped = [];
    if (resp && resp.Status == 1 && Array.isArray(resp.Data)) {
      mapped = resp.Data.map(function (x) {
        if (x && typeof x === 'object') {
          return { code: String(x.StateCode || x.StateName || ''), name: String(x.StateName || x.StateCode || '') };
        }
        return { code: String(x || ''), name: String(x || '') };
      }).filter(function (r) { return r.code && r.name; });
    } else {
      console.warn('[EU] API returned no regions for', iso2);
    }

    // Update live list and cache under ISO2 key for this session
    $scope.eu.regions = mapped;
    if (mapped.length) {
      $scope.eu.regionsByCountry[iso2] = mapped;
    }
    $scope.enrollment.mailingAddress.State = null;
  }, function (err) {
    console.error('[EU] fetchRegionsFromAPI error:', err);
    $scope.eu.regions = [];
    $scope.enrollment.mailingAddress.State = null;
  }).then(function () {
    $scope.isRegionsLoading = false;
    $scope.$applyAsync();
  });
};

// ---- Handlers ----
$scope.onCountryChange = function () {
  var countryVal = $scope.enrollment.mailingAddress && $scope.enrollment.mailingAddress.Country;
  // Prefer ISO2 guess for API fallback too
  var isoGuess = COUNTRY_TO_ISO2[countryVal] || String(countryVal || '').toUpperCase();

  var key = resolveCountryKey(countryVal, $scope.eu.regionsByCountry);
  console.log('[EU] onCountryChange country=', countryVal, '→ key=', key, 'isoGuess=', isoGuess);

  $scope.isRegionsLoading = true;

  var raw = key ? ($scope.eu.regionsByCountry[key] || []) : [];
  if (!raw.length && isoGuess && isoGuess.length === 2) {
    console.warn('[EU] No JSON regions for', isoGuess, '— attempting API fallback.');
    // API will populate eu.regions; return early
    $scope.fetchRegionsFromAPI(isoGuess);
    return;
  }

  $scope.eu.regions = normalizeRegions(raw);
  $scope.enrollment.mailingAddress.State = null;

  $scope.$evalAsync(function () {
    $scope.isRegionsLoading = false;
    console.log('[EU] regions initialized (JSON):', $scope.eu.regions.length, $scope.eu.regions.slice(0, 5));
  });
};

// ---- Init & watchers (with basic retry for late-loaded JSON) ----
(function initEURegions() {
  function tryLoad() {
    var data = readEuJson();
    if (Object.keys(data).length) {
      $scope.eu.regionsByCountry = data;
      if ($scope.enrollment?.mailingAddress?.Country) $scope.$evalAsync($scope.onCountryChange);
      return true;
    }
    return false;
  }

  if (!tryLoad()) {
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (tryLoad() || attempts > 10) clearInterval(timer); // ~1s retries
    }, 100);
  }
})();

// Refresh regions whenever country changes
$scope.$watch('enrollment.mailingAddress.Country', function (n, o) {
  if (n !== o) $scope.onCountryChange();
});




$scope.saveCustomFields = function () {
  $rootScope.showLoader();

  const request = {
    customerId: 0,
    backOfficeId: "",
    sponsorId: ($rootScope.EnrollerInfo && $rootScope.EnrollerInfo.AssociateID) ? $rootScope.EnrollerInfo.AssociateID : 0,
    customerType: 1,
    username: $scope.enrollment.webOffice.UserName,
    webAlias: $scope.enrollment.webOffice.UserName,
    textPhone: $scope.enrollment.mailingAddress.Contact,
    password: $scope.enrollment.webOffice.Password,
    birthDate: $scope.enrollment.personalInfo.birthMonth + "/" + $scope.enrollment.personalInfo.birthDay + "/" + $scope.enrollment.personalInfo.birthYear,
    taxID: $scope.enrollment.commissionPayment,
    CompanyName: "",
    languageCode: "",
    checkoutId: "",
    checkoutWebUrl: "",
    email: $scope.enrollment.personalInfo.Email,
    checkoutType: "enrollment"
  };

  return new Promise((resolve) => {
    try {
      const ret = window.DI.Enrollment.saveCustomFields(request);

      if (ret && typeof ret.then === "function") {
        ret.then(
          (response) => {
            // keep your behavior, but return boolean
            if (response) {
              $scope.onLastSection = true;
              ($scope.$applyAsync && $scope.$applyAsync()) || $scope.$apply();
              resolve(true);
            } else {
              window.DI.DI.notification("Error", "Something went wrong!", "error");
              resolve(false);
            }
            $rootScope.hideLoader();
          },
          () => {
            resolve(false);
            $rootScope.hideLoader();
          }
        );
        return;
      }

      resolve(false);
      $rootScope.hideLoader();
    } catch (e) {
      resolve(false);
      $rootScope.hideLoader();
    }
  });
};


function enableFinalStep() {
  $scope.onLastSection = true;
  ($scope.$applyAsync && $scope.$applyAsync()) || $scope.$apply();
}

function disableFinalStep() {
  $scope.onLastSection = false;
  ($scope.$applyAsync && $scope.$applyAsync()) || $scope.$apply();
}

$scope.tryEnableFinalButton = async function () {
  // 1) try normal save
  const saved = await $scope.saveCustomFields();
  if (saved) {
    enableFinalStep();
    return true;
  }

  // 2) fallback requires consultant
  const enrollerInfoRaw = localStorage.getItem("enrollerinfo");
  if (!enrollerInfoRaw || enrollerInfoRaw === "null") {
    const el = document.getElementById("consultantInput");
    if (el) {
      el.classList.add("pink-placeholder");
      el.placeholder = "Please enter your consultant's name";
    }
    window.DI.DI.notification("Error", "Please enter your consultant's name", "error");
    disableFinalStep();
    return false;
  }

  const item = JSON.parse(enrollerInfoRaw);
  const consultantID = item.AssociateID || 0;
  const consultantName = `${item.ContactFirstName || ""} ${item.ContactLastName || ""}`.trim();

  const password = $scope.enrollment.webOffice.Password;
  const webAlias = $scope.enrollment.webOffice.UserName;
  const socialSecurityNumber = $scope.enrollment.personalInfo.socialSecurity;
  const phoneNumber = $scope.enrollment.mailingAddress.Contact;
  const State = $scope.enrollment.mailingAddress.State;
  const Country = $scope.enrollment.mailingAddress.Country;
  const languageInfo = sessionStorage.getItem("otpLang") || "en";
  const birthDate =
    $scope.enrollment.personalInfo.birthMonth + "/" +
    $scope.enrollment.personalInfo.birthDay + "/" +
    $scope.enrollment.personalInfo.birthYear;

  const cartOk = await updateCartWithConsultantInfo(
    consultantID,
    consultantName,
    password,
    webAlias,
    birthDate,
    socialSecurityNumber,
    phoneNumber,
    State,
    Country,
    languageInfo
  );

  if (cartOk) {
    enableFinalStep();
    return true;
  }

  window.DI.DI.notification("Error", "Could not save your info. Please try again.", "error");
  disableFinalStep();
  return false;
};


    $scope.calculateShippingTotal = function (saveCustomFields = false) {
      if (!$scope.enrollment.selectedShippingMethod) {
        $scope.enrollment.selectedShippingMethod = calculateService.createCheckoutResponse.availableShippingRates.shippingRates[0]['handle'];
      }

      $rootScope.showLoader();
      let request = {
        "checkoutId": "",  // No need for checkoutId
        "shippingRateHandle": $scope.enrollment.selectedShippingMethod
      };
      window.DI.Enrollment.calculateShippingTotal(request).then(function (response, error) {
        if (response.checkoutShippingLineUpdate && response.checkoutShippingLineUpdate.checkoutUserErrors.length == 0) {
          response = response.checkoutShippingLineUpdate.checkout;
          if (response.availableShippingRates == null || response.availableShippingRates.ready == false) {
            $rootScope.hideLoader();
            $scope.GetShippingMethods();
            return;
          }
          calculateService.createCheckoutResponse = response;
          $rootScope.hideLoader();
          if (saveCustomFields) {
            $scope.saveCustomFields();
          }
         fetchUpdatedCartData(); // Fetch and update cart data
        } else if (response.checkoutShippingLineUpdate && response.checkoutShippingLineUpdate.checkoutUserErrors.length > 0) {
          let errors = response.checkoutShippingLineUpdate.checkoutUserErrors;
          errors.forEach(error => {
            window.DI.DI.notification("Error", error.message, "error");
          });
          $rootScope.hideLoader();
        } else {
          $rootScope.hideLoader();
        }
      }).catch((error) => {
        $rootScope.hideLoader();
      });
    };

    $scope.UpdateEmailtoCheckoutAndPlace = function () {
      if ($scope.enrollment.personalInfo.Email == "" || !$scope.enrollment.personalInfo.Email) {
        window.DI.DI.notification("Error", "Please verify your email address", "error");
        return;
      }

      $rootScope.showLoader();

      const password = $scope.enrollment.webOffice.Password;
      const webAlias = $scope.enrollment.webOffice.UserName;
      const socialSecurityNumber = $scope.enrollment.personalInfo.socialSecurity;
      const phoneNumber = $scope.enrollment.mailingAddress.Contact;
      const State = $scope.enrollment.mailingAddress.State;
      const Country = $scope.enrollment.mailingAddress.Country;

      const birthDate = $scope.enrollment.personalInfo.birthMonth + "/" + $scope.enrollment.personalInfo.birthDay + "/" + $scope.enrollment.personalInfo.birthYear;

      const enrollerInfo = localStorage.getItem("enrollerinfo");
      const languageInfo = sessionStorage.getItem("otpLang") || "en";

if (enrollerInfo == null || enrollerInfo === "null") {
  $rootScope.hideLoader();
  const el = document.getElementById("consultantInput");
  if (el) {
    el.classList.add("pink-placeholder");
    el.placeholder = "Please enter your consultant's name";
  }
  return; // ✅ this is the USA behavior
}



      if (enrollerInfo) {
        const item = JSON.parse(enrollerInfo);
        const consultantID = item.AssociateID;
        const consultantName = `${item.ContactFirstName} ${item.ContactLastName}`;

        updateCartWithConsultantInfo(consultantID, consultantName, password, webAlias, birthDate, socialSecurityNumber, phoneNumber, State, Country, languageInfo)
          .then(() => {
            proceedToCheckout();
          })
          .catch((error) => {
            console.error("Failed to update cart with consultant info", error);
            $rootScope.hideLoader();
          });
      } else {
        proceedToCheckout();
      }
    };

function updateCartWithConsultantInfo(consultantID, consultantName, password, webAlias, birthDate, socialSecurityNumber, phoneNumber, State, Country, languageInfo) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/update.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            const response = JSON.parse(xhr.responseText);
            console.log('Updated cart:', response);
            fetchUpdatedCartData(); // Fetch and update cart data if needed
            resolve(response);
          } catch (error) {
            console.error('Error parsing response JSON:', error);
            reject(error);
          }
        } else {
          console.error('Error with network request:', xhr.status, xhr.statusText);
          reject(new Error(`Network error: ${xhr.status} ${xhr.statusText}`));
        }
      }
    };

    const existingReferralCookie = getCookie('existingReferral');
    const landing_page_cookie = getCookie('landingPage');
    const landingPageSession = sessionStorage.getItem('landingPage') || 'Landing page did not save.';
    const closedPopupValue = sessionStorage.getItem('selectedSkip') || 'false';

    const sponsorSearchValue = sessionStorage.getItem('sponsorSearch');
    const sponsorSearch = sponsorSearchValue
      ? 'true - searched and selected consultant link: ' + sponsorSearchValue
      : 'false';

    const noteContent = `ExistingReferral: ${existingReferralCookie}
LandingPageCookie: ${landing_page_cookie}
LandingPageSession: ${landingPageSession}
PressedSkip: ${closedPopupValue}
SponsorSearch: ${sponsorSearch}`;

    const data = {
      note: noteContent,
      attributes: {
        ConsultantID: consultantID,
        ConsultantName: consultantName,
        password: password,
        webAlias: webAlias,
        birthDate: birthDate,
        socialSecurityNumber: socialSecurityNumber,
        phone: phoneNumber,
        country: Country,
        language: languageInfo,
        state: State
      }
    };

    console.log('Payload:', JSON.stringify(data, null, 2));
    xhr.send(JSON.stringify(data));
  });
}


    function proceedToCheckout() {
      $rootScope.hideLoader();
      
      // Collect all necessary details from $scope.enrollment for shipping address
      const email = encodeURIComponent($scope.enrollment.personalInfo.Email);
      const shippingFirstName = encodeURIComponent($scope.enrollment.mailingAddress.FirstName);
      const shippingLastName = encodeURIComponent($scope.enrollment.mailingAddress.LastName);
      const shippingAddress1 = encodeURIComponent($scope.enrollment.mailingAddress.StreetAddress);
      const shippingAddress2 = encodeURIComponent($scope.enrollment.mailingAddress.Apartment || '');
      const shippingCity = encodeURIComponent($scope.enrollment.mailingAddress.City);
      const shippingProvince = encodeURIComponent($scope.enrollment.mailingAddress.State || "");
      const shippingZip = encodeURIComponent($scope.enrollment.mailingAddress.ZipCode || "");
      const shippingCountry = encodeURIComponent($scope.enrollment.mailingAddress.Country || "US");
    
      // Collect all necessary details from $scope.enrollment for billing address
      const billingFirstName = encodeURIComponent($scope.enrollment.mailingAddress.FirstName);
      const billingLastName = encodeURIComponent($scope.enrollment.mailingAddress.LastName);
      const billingAddress1 = encodeURIComponent($scope.enrollment.mailingAddress.StreetAddress);
      const billingAddress2 = encodeURIComponent($scope.enrollment.mailingAddress.Apartment || '');
      const billingCity = encodeURIComponent($scope.enrollment.mailingAddress.City);
      const billingProvince = encodeURIComponent($scope.enrollment.mailingAddress.State || "");
      const billingZip = encodeURIComponent($scope.enrollment.mailingAddress.ZipCode || "");
      const billingCountry = encodeURIComponent($scope.enrollment.mailingAddress.Country || "US");
    
      // Construct the URL with all parameters for both shipping and billing addresses
      const checkoutUrl = `/checkout?checkout[email]=${email}&checkout[shipping_address][first_name]=${shippingFirstName}&checkout[shipping_address][last_name]=${shippingLastName}&checkout[shipping_address][address1]=${shippingAddress1}&checkout[shipping_address][address2]=${shippingAddress2}&checkout[shipping_address][city]=${shippingCity}&checkout[shipping_address][province]=${shippingProvince}&checkout[shipping_address][zip]=${shippingZip}&checkout[shipping_address][country]=${shippingCountry}&checkout[billing_address][first_name]=${billingFirstName}&checkout[billing_address][last_name]=${billingLastName}&checkout[billing_address][address1]=${billingAddress1}&checkout[billing_address][address2]=${billingAddress2}&checkout[billing_address][city]=${billingCity}&checkout[billing_address][province]=${billingProvince}&checkout[billing_address][zip]=${billingZip}&checkout[billing_address][country]=${billingCountry}`;
      
      // Redirect to the constructed URL
      $window.location.href = checkoutUrl;
    }



    function handleErrorsFromResponse(response) {
      $scope.onLastSection = false;
      if (response.checkoutEmailUpdateV2 && response.checkoutEmailUpdateV2.checkoutUserErrors.length > 0) {
        let errors = response.checkoutEmailUpdateV2.checkoutUserErrors;
        $rootScope.hideLoader();
        errors.forEach(error => {
          window.DI.DI.notification("Error", error.message, "error");
        });
      } else {
        $rootScope.hideLoader();
      }
    }

    $scope.addDefaultKitItem = async function () {
      try {
        if ($rootScope.BundlePack.length && ($rootScope.BundlePack.findIndex((pack) => pack.variant_id == $scope.DefaultEnrollKit.variants[0].id) > -1)) {
          $rootScope.hideLoader();
          return;
        };
        if (Object.keys($scope.DefaultEnrollKit).length > 0) {
          const DefaultEnrollKit = {
            "id": $scope.DefaultEnrollKit.id,
            "quantity": 1,
            "variant_id": $scope.DefaultEnrollKit.variants[0].id,
            "product_title": $scope.DefaultEnrollKit.title,
            "price": $scope.DefaultEnrollKit.price,
            "sku": $scope.DefaultEnrollKit.variants[0].sku,
            "handle": $scope.DefaultEnrollKit.handle,
            "image": $scope.DefaultEnrollKit.featured_image
          };
          $rootScope.BundlePack.push(DefaultEnrollKit);
        }
        console.log("DefaultEnrollKit", DefaultEnrollKit);
      } catch {
        $rootScope.hideLoader();
      }
    };

    $scope.getBundleItems = function () {
      jQuery.getJSON("/cart.js", async function (cart) {
        const DefaultEnrollKit = $('#oliveda-enrollment__KitItem').text();
        if (DefaultEnrollKit) {
          $scope.DefaultEnrollKit = JSON.parse(DefaultEnrollKit);
        }

        let oldItems = $rootScope.BundlePack;
        $rootScope.BundlePack = cart.items;

        $scope.$apply();
        localStorage.setItem("cart.bundle", JSON.stringify(theme.dzStrings.cart.items));

        if (JSON.stringify(oldItems) != JSON.stringify($rootScope.BundlePack) && $rootScope.BundlePack.length) {
          $rootScope.hideLoader();
          return;
        }

        if ($rootScope.BundlePack.length && !sessionStorage.getItem('_enrollmentCheckoutID')) {
          $rootScope.hideLoader();
          return;
        }

        if (JSON.stringify(oldItems) == JSON.stringify($rootScope.BundlePack) && $rootScope.BundlePack.length) {
          $rootScope.hideLoader();
        }
      });
    };

    if (!$scope.isEnrollmentJoinPage) {
      $scope.getBundleItems();
    }

    function isEnrollmentKitAdded() {
      return ($rootScope.BundlePack.findIndex((item) => item.handle == "digital-enrollment-kit") > -1) || false;
    }

    $scope._addKitToCart = function (variantId, handle) {
      try {
        if (handle == "digital-enrollment-kit" && isEnrollmentKitAdded()) {
          window.DI.DI.notification("Error", "Digital Enrollment Kit already added", "error");
          return;
        }

        $rootScope.showLoader();
        var data = {
          id: variantId,
          quantity: 1,
        };
        
        const urlParams = new URLSearchParams(window.location.search);
        const isAmishPerson = urlParams.has('AmishPerson');

       if (variantId == "42374991282371" && !isAmishPerson) {
        data.selling_plan = 1798930627;
      }
        const activeFlag = window.activeFlag !== undefined ? window.activeFlag : false; // Default to false if undefined
        console.log('going to call check and add');
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: data,
          dataType: "json",
          success: function () {
            window.DI.DI.notification("Success", "Item Added Successfully!", "success");
            $scope.getBundleItems();
            fetchUpdatedCartData(); // Fetch and update cart data // Call updateCart here
            checkAndAddItemIfNeeded();
            if(activeFlag) {
             validateAndCheckAddItem();
            }
              window.location.reload();

          },
          error: function () {
            $rootScope.hideLoader();
          },
        });
      } catch (error) {
        $rootScope.hideLoader();
      }
    };

   async function checkAndAddItemIfNeeded() {
     console.log('inside check and add');
    const cart = await fetchCart();
    const promoSku = "55041PROMO";
    const requiredSku = "80065";
    const skuList = ["80068", "80066", "80067", "80069", "80070", "80071", "80072", "80073"];
    const itemToAddId = '51923311264110'; // Replace with the variant ID of the item to be auto-added

    // Check if promo SKU is not in the cart
    const isPromoInCart = cart.items.some(item => item.sku === promoSku);

    // Check if required SKU is in the cart
    const isRequiredSkuInCart = cart.items.some(item => item.sku === requiredSku);

    // Check if any SKU from the list is in the cart
    const isAnySkuInCart = cart.items.some(item => skuList.includes(item.sku));

    // Apply conditions
    if (!isPromoInCart && isRequiredSkuInCart && isAnySkuInCart) {
        // Check if the item to add is already in the cart
        const itemExists = cart.items.some(item => item.variant_id === itemToAddId);

        if (!itemExists) {
            try {
                // Auto-add the item
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        id: itemToAddId,
                        quantity: 1
                    })
                });

                const responseData = await response.json();
                if (!response.ok) {
                    console.error('Server response when adding item:', responseData);
                    throw new Error('Failed to add item to cart.');
                }

                console.log('Item successfully added to cart:', responseData);
                window.location.reload(true);

            } catch (error) {
                console.error('Error adding item to cart:', error);
            }
        } else {
            console.log('Item already in the cart, skipping auto-add.');
        }
    } else {
        console.log(`Conditions not met, no item will be auto-added.`);
    }
}

async function validateAndCheckAddItem() {
    // Retrieve the consultant flag and date/time constraints from theme settings or metafields
    const consultantFlag = window.consultantFlag !== undefined ? window.consultantFlag : false; // Default to false if not defined
    const startDate = window.startDate !== undefined ? window.startDate : null; // Default to null if not defined
    const startTime = window.startTime !== undefined ? window.startTime : null; // Default to null if not defined
    const endDate = window.endDate !== undefined ? window.endDate : null; // Default to null if not defined
    const endTime = window.endTime !== undefined ? window.endTime : null; // Default to null if not defined

    let eligble = 0;
    // Check if the customer is tagged as 'consultant'
    const customerTags = window.customerTags && Array.isArray(window.customerTags) ? window.customerTags : [];
    const isConsultant = customerTags.includes('consultant') && consultantFlag === '1';

    if(consultantFlag == 1 || consultantFlag == '1')
    {
      eligble = 1;
    }
    if(customerTags.includes('consultant') && consultantFlag == '0') {
      eligble = 0;
    }
    if(!customerTags.includes('consultant')) {
        eligble = 1;
      }
  
    // Check if the current date and time are within the specified range
    const isValidDateTime = isWithinDateTimeRange(startDate, startTime, endDate, endTime);

    // Call the function only if both constraints are satisfied
    if (eligble && isValidDateTime) {
        console.log("its in the promo constraints");
        // Check if the subtotal is 199 before tax and add the item if needed
         checkAndAddItemIfNeeded_gift();
    } else {
        console.log("Constraints not met. Function not called.");
    }
}
async function checkAndAddItemIfNeeded_gift() {
    try {
        const cart = await fetchCart();
        const subtotalBeforeTax = cart.items_subtotal_price / 100; // Convert to currency
        const itemToAddId = window.itemToAddId || null; // Default to null if not defined
        const requiredSubtotal = window.requiredSubtotal !== undefined ? window.requiredSubtotal : 199; // Default to 199 if not defined


        if (subtotalBeforeTax > requiredSubtotal) {
            const itemExists = cart.items.some(item => item.variant_id.toString().trim() === itemToAddId);

            if (!itemExists) {
                try {
                    const response = await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            id: itemToAddId,
                            quantity: 1
                        })
                    });

                    const responseData = await response.json();
                    if (!response.ok) {
                        throw new Error('Failed to add item to cart.');
                    }
                  console.log('Item successfully added to cart:', responseData);
                } catch (error) {
                    console.error('Error adding item to cart:', error);
                }
            }
        }
    } catch (error) {
        console.error("Error in checkAndAddItemIfNeeded function:", error);
    }
}
    
async function fetchCart() {
    const response = await fetch('/cart.js');
    if (!response.ok) {
        console.error('Failed to fetch cart data:', response.statusText);
        throw new Error('Failed to fetch cart data.');
    }
    return await response.json();
}
    
    $scope.shopify_changeItem = async function (variant_id, quantity) {
      const promise = new Promise((res, rej) => {
        var req = {
          type: "POST",
          url: "/cart/change.js",
          data: "quantity=" + quantity + "&id=" + variant_id,
          dataType: "json",
          success: function (result) {
            fetchUpdatedCartData(); // Fetch and update cart data // Call updateCart here
            return res(result);
          },
          error: function (err) {
            return rej(err);
          }
        };
        jQuery.ajax(req);
      });
      return Promise.all([promise]);
    };

    $scope._removeKitToCart = function (variantId, handle) {
      try {
        $rootScope.showLoader();
        $scope.shopify_changeItem(variantId, 0)
          .then(() => {
              fetchUpdatedCartData(); // Fetch and update cart data/ Call updateCart here
            window.DI.DI.notification("Success", "Item Deleted Successfully!", "success");
             fetchUpdatedCartData(); // Fetch and update cart data // Call updateCart here
            if ($rootScope.BundlePack.length == 1) {
              window.location.reload();
              return;
            }
            $scope.getBundleItems();
            $rootScope.hideLoader();
          })
          .catch(() => {
            $rootScope.hideLoader();
          });
      } catch (error) {
        $rootScope.hideLoader();
      }
    };

    $scope._updateEnrollmentCart = async function () {
      try {
        const bundle_pack = [...$rootScope.BundlePack];
        if (bundle_pack.length == 0)
          return;

        bundle_pack.map((pack) => {
          if (!pack.quantity || pack.quantity <= 0) {
            window.DI.DI.notification("Error", "Wrong Quantity, Please enter correctly!", "error");
            $scope.getBundleItems();
            return;
          }
        });

        $rootScope.showLoader();
        $scope.shopify_updateItem(0);
        fetchUpdatedCartData(); // Fetch and update cart data// Call updateCart here
      } catch (error) {
        $rootScope.hideLoader();
      }
    };

    $scope.shopify_updateItem = function (index) {
      try {
        const bundle_pack = [...$rootScope.BundlePack];
        const responses = [];
        var update = () => {
          var req = {
            type: "POST",
            url: "/cart/change.js",
            data: "quantity=" + bundle_pack[index].quantity + "&id=" + bundle_pack[index].variant_id,
            dataType: "json",
            success: function (result) {
              responses.push(result);
              fetchUpdatedCartData();
              if (responses.length !== bundle_pack.length) {
                index += 1;
                return update(bundle_pack[index].variant_id, bundle_pack[index].quantity);
              } else {
                window.DI.DI.notification("Success", "Items Updated Successfully!", "success");
                $scope.getBundleItems();
               fetchUpdatedCartData(); // Fetch and update cart data // Call updateCart here
              }
            },
            error: function (err) { }
          };
          jQuery.ajax(req);
        };
        update();
      } catch (error) {
        $rootScope.hideLoader();
      }
    };

$scope.viewProductInfo = function (imageUrl, productHandle) {
  console.log('[viewProductInfo] open image', { productHandle, imageUrl });
  if (!imageUrl) return;

  var modalInstance = $uibModal.open({
    animation: true,

    // ✅ allow click outside to close
    backdrop: true,
    keyboard: true,
    closeOnEscape: true,

    windowClass: 'starter-set-popup',
    template:
      '<div class="modal-body" style="padding:0 !important; text-align:center !important; position:relative !important; background:#fff !important; opacity:1 !important; visibility:visible !important;">' +
        '<button type="button" class="close" style="position:absolute !important; right:12px !important; top:8px !important; z-index:1000 !important; font-size:28px !important; opacity:1 !important; color:#000 !important; background:transparent !important; border:none !important; cursor:pointer !important;" ng-click="$dismiss()">' +
          '<span>&times;</span>' +
        '</button>' +
        '<img id="popup-product-image" style="display:block !important; width:100% !important; max-width:900px !important; height:auto !important; margin:0 auto !important; background:#fff !important; opacity:1 !important; visibility:visible !important;" />' +
      '</div>'
  });

  modalInstance.opened.then(function () {
    // get the most recently opened modal
    var modals = document.querySelectorAll('.modal.starter-set-popup');
    var modalEl = modals[modals.length - 1];
    if (!modalEl) return;

    // 🔒 force outer modal visibility
    modalEl.style.setProperty('z-index', '999999', 'important');
    modalEl.style.setProperty('display', 'block', 'important');
    modalEl.style.setProperty('position', 'fixed', 'important');
    modalEl.style.setProperty('top', '0', 'important');
    modalEl.style.setProperty('left', '0', 'important');
    modalEl.style.setProperty('width', '100vw', 'important');
    modalEl.style.setProperty('height', '100vh', 'important');
    modalEl.style.setProperty('background', 'rgba(0,0,0,0.6)', 'important');
    modalEl.style.setProperty('opacity', '1', 'important');
    modalEl.style.setProperty('visibility', 'visible', 'important');

    // 🎯 position modal-dialog at 25% from top
    var dialog = modalEl.querySelector('.modal-dialog');
    if (dialog) {
      dialog.style.setProperty('position', 'relative', 'important');
      dialog.style.setProperty('top', '25%', 'important');
      dialog.style.setProperty('transform', 'translateY(-25%)', 'important');
    }

    // 🖼️ guaranteed src set (retry until img exists)
    var tries = 0;
    (function setSrcWhenReady() {
      tries++;

      var img = modalEl.querySelector('#popup-product-image');
      if (img) {
        img.src = imageUrl;
        console.log('[viewProductInfo] img src set (tries=' + tries + '):', img.src);
        return;
      }

      if (tries < 20) {
        setTimeout(setSrcWhenReady, 25);
      } else {
        console.warn('[viewProductInfo] img never appeared to set src');
      }
    })();
  });
};











    $scope.getStarterImage = function (productHandle) {
      let productImage = "https://cdn.shopify.com/s/files/1/0550/6085/7039/files/";
      productImage = productImage + "enroll-starter-" + productHandle + ".jpg";
      return productImage;
    };

    $scope.ContinueStep1 = function () {
      $scope.UpdateToNextStep(2);
    };

    $scope.ContinueStep2 = function () {
      $scope.UpdateToNextStep(3);
    };

    $scope.createEnrollmentExtraFields = function () {
      try {
        $rootScope.showLoader();
        let request = {
          "customerId": 0,
          "backOfficeId": "",
          "sponsorId": $rootScope.EnrollerInfo.AssociateID ? $rootScope.EnrollerInfo.AssociateID : 0 || 0,
          "customerType": 1,
          "username": $scope.enrollment.webOffice.UserName,
          "webAlias": $scope.enrollment.webOffice.UserName,
          "textPhone": $scope.enrollment.mailingAddress.Contact,
          "password": $scope.enrollment.webOffice.Password,
          "birthDate": $scope.enrollment.personalInfo.birthMonth + "/" + $scope.enrollment.personalInfo.birthDay + "/" + $scope.enrollment.personalInfo.birthYear,
          "taxID": $scope.enrollment.commissionPayment,
          "CompanyName": "",
          "languageCode": "",
          "checkoutId": "",
          "checkoutWebUrl": "",
          "email": $scope.enrollment.personalInfo.Email,
          "checkoutType": "free-enrollment",
          "address1": $scope.enrollment.mailingAddress.StreetAddress,
          "address2": $scope.enrollment.mailingAddress.Apartment,
          "city": $scope.enrollment.mailingAddress.City,
          "provinceCode": $scope.enrollment.mailingAddress.State || "UT",
          "countryCode": $scope.enrollment.mailingAddress.Country || "US",
          "zip": $scope.enrollment.mailingAddress.ZipCode || "84042",
        };
        window.DI.Enrollment.saveCustomFields(request)
          .then(function (response, error) {
            if (response) {
              $scope.createCustomerInShopify();
            } else {
              window.DI.DI.notification("Error", "Something went wrong!", "error");
            }
          }).catch((error) => {
            $rootScope.hideLoader();
          });
      } catch (error) {
        $rootScope.hideLoader();
      }
    };

    $scope.createCustomerInShopify = function () {
      try {
        let request = {
          "input": {
            "acceptsMarketing": true,
            "email": $scope.enrollment.personalInfo.Email,
            "firstName": $scope.enrollment.mailingAddress.FirstName,
            "lastName": $scope.enrollment.mailingAddress.LastName,
            "password": $scope.enrollment.webOffice.Password,
            "phone": "+1" + $scope.enrollment.mailingAddress.Contact
          }
        };
        console.log(request);
        window.DI.Enrollment.customerCreate(request).then(function (response, error) {
          if (response.customerCreate && response.customerCreate.customer && response.customerCreate.customer.email) {
            window.DI.DI.notification("Success", "You have been successfully enrolled!", "success");
            setTimeout(() => {
              window.location.href = '/pages/enrollment-kit';
            }, 100);
          } else if (response.customerCreate.customerUserErrors && response.customerCreate.customerUserErrors.length > 0) {
            let errors = response.customerCreate.customerUserErrors;
            errors.forEach(error => {
              window.DI.DI.notification("Error", error.message, "error");
            });
          }
          $rootScope.hideLoader();
        }).catch((Error) => {
          console.log(Error);
          window.DI.DI.notification("Error", Error.responseText, "error");
          $rootScope.hideLoader();
        });
      } catch (error) {
        $rootScope.hideLoader();
      }
    };

    $scope.SubmitEnrollment = function () {
      if (!$scope.isPhoneChecked) {
        window.DI.DI.notification("Error", "Please verify your Phone Number", "error");
        return;
      }
      if (!$scope.isEmailChecked) {
        window.DI.DI.notification("Error", "Please verify your Email Address", "error");
        return;
      }
      $scope.createEnrollmentExtraFields();
    };

    $scope.elementWithNoError = function (target) {
      try {
        if (target === 'confirmEmail') {
          if ($('#txtEmailAdd2').closest('.control-group').find('.has-error')[0]) {
            return false;
          }
        }
        if (target === 'username') {
          if ($('#username').closest('.control-group').find('.has-error')[0]) {
            return false;
          }
        }
      } catch (error) { }
      return true;
    };

$scope.SubmitApplicationForm = async function () {
  if (!isEnrollmentKitAdded()) {
    window.DI.DI.notification("Error", "Please add Enrollment Kit", "error");
    return;
  }
  await $scope.tryEnableFinalButton();
};



    const showLogoutPopup = (customer_id) => {
      $rootScope.showLoader();
      $.get('/search?q=&view=showlogoutpopup')
        .then(function (response) {
          $rootScope.hideLoader();
          var template = $templateCache.put('showlogoutpopup.html', response);
          $uibModal.open({
            animation: true,
            templateUrl: 'showlogoutpopup.html',
            backdrop: 'static',
            keyboard: true,
            closeOnEscape: false,
            windowClass: 'uibmodalclass',
            controllerAs: 'ShowLogoutPopupCtrl',
            controller: ['$rootScope', '$scope', '$uibModalInstance', function ($rootScope, $scope, $uibModalInstance) {

              var ShowLogoutPopupCtrl = this;
              ShowLogoutPopupCtrl.close = $uibModalInstance.close;
              ShowLogoutPopupCtrl.CustomerName = '';

              // Get Logged In User Details
              ShowLogoutPopupCtrl._getUserDetails = function () {
                let request = {
                  customerId: parseInt(customer_id, 10),
                  fields: ""
                };
                window.DI.Enrollment.GetShopifyCustomer(request)
                  .then((response) => {
                    if (response && response.FirstName && response.LastName) {
                      ShowLogoutPopupCtrl.CustomerName = `${response.FirstName} ${response.LastName}`;
                      $scope.$apply();
                    }
                  })
                  .catch();
              };
              ShowLogoutPopupCtrl._getUserDetails();

              $(document).ready(function () {
                var REDIRECT_PATH = "/pages/enrollment";
                var logoutBtn = document.querySelector('a[href^="/account/logout?source=enrollment"]');
                if (logoutBtn) {
                  logoutBtn.addEventListener('click', function () {
                    fetch(logoutBtn.href)
                      .then(() => window.location.href = REDIRECT_PATH)
                      .catch();
                  });
                }
              });
            }]
          });
        })
        .catch(() => $rootScope.hideLoader());
    };

const showAgreementPopup = () => {
  $rootScope.showLoader();
  $.get('/search?q=&view=showagreement')
    .then(function (response) {
      $rootScope.hideLoader();
      $templateCache.put('showagreement.html', response);
      $uibModal.open({
        animation: true,
        templateUrl: 'showagreement.html',
        backdrop: 'static',
        keyboard: true,
        closeOnEscape: false,
        windowClass: 'uibmodalclass',
        controllerAs: 'ShowAgreementPopupCtrl',
        controller: ['$rootScope', '$scope', '$uibModalInstance', function ($rootScope, $scope, $uibModalInstance) {
          var ShowAgreementPopupCtrl = this;
          ShowAgreementPopupCtrl.close = $uibModalInstance.close;
        
          $scope.initSignaturePad = function () {
            const canvas = document.getElementById("signatureCanvas");
            const ctx = canvas.getContext("2d");
            const clearBtn = document.getElementById("clearSignature");
            const submitBtn = document.getElementById("submitAgreement");
            const nameInput = document.getElementById("consultantName");
        
            let drawing = false;
        
            canvas.addEventListener("mousedown", () => {
              drawing = true;
              ctx.beginPath();
            });
        
            canvas.addEventListener("mouseup", () => {
              drawing = false;
            });
        
            canvas.addEventListener("mousemove", (event) => {
              if (!drawing) return;
              const rect = canvas.getBoundingClientRect();
              const x = event.clientX - rect.left;
              const y = event.clientY - rect.top;
              ctx.lineTo(x, y);
              ctx.stroke();
            });
        
            // Touch support
            canvas.addEventListener("touchstart", function (e) {
              e.preventDefault();
              drawing = true;
              const rect = canvas.getBoundingClientRect();
              const touch = e.touches[0];
              const x = touch.clientX - rect.left;
              const y = touch.clientY - rect.top;
              ctx.beginPath();
              ctx.moveTo(x, y);
            });
        
            canvas.addEventListener("touchmove", function (e) {
              e.preventDefault();
              if (!drawing) return;
              const rect = canvas.getBoundingClientRect();
              const touch = e.touches[0];
              const x = touch.clientX - rect.left;
              const y = touch.clientY - rect.top;
              ctx.lineTo(x, y);
              ctx.stroke();
            });
        
            canvas.addEventListener("touchend", function () {
              drawing = false;
            });
        
            clearBtn.addEventListener("click", () => {
              ctx.clearRect(0, 0, canvas.width, canvas.height);
            });
        
            function isCanvasBlank(canvas) {
              const blank = document.createElement('canvas');
              blank.width = canvas.width;
              blank.height = canvas.height;
              return canvas.toDataURL() === blank.toDataURL();
            }
        
            submitBtn.addEventListener("click", () => {
              
              const name = nameInput.value.trim();
              const signatureWarning = document.getElementById("signatureWarning");
            
              // Reset any previous red text/placeholder
              nameInput.classList.remove("pink-placeholder");
              nameInput.placeholder = "Enter your full name";
              signatureWarning.classList.add("displayNone");
            
              // Validate name
              if (!name) {
                nameInput.placeholder = "Please enter your full name";
                nameInput.classList.add("pink-placeholder");
                return;
              }
            
              // Signature validation
              if (isCanvasBlank(canvas)) {
                if (signatureWarning) signatureWarning.classList.remove("displayNone");
                return;
              }

        
              const signatureDataURL = canvas.toDataURL();
              sessionStorage.setItem("consultantAgreementName", name);
              sessionStorage.setItem("consultantAgreementSignature", signatureDataURL);
        
              $uibModalInstance.close(); // optional: auto-close modal after submit
            });
          };
        
          // Initialize signature pad when modal renders
          setTimeout(() => $scope.initSignaturePad(), 100); // wait for DOM render
        }]

      });
    })
    .catch(() => $rootScope.hideLoader());
};
    
$scope.checkConsultantAgreement = function () {
  const name = sessionStorage.getItem("consultantAgreementName");
  const signature = sessionStorage.getItem("consultantAgreementSignature");

  $scope.checkboxes = $scope.checkboxes || {};
  if (name && signature) {
    $scope.checkboxes.accept3 = true;
  } else {
    $scope.checkboxes.accept3 = false;
  }
};

$scope.handleConsultantAgreementClick = function () {
  const name = sessionStorage.getItem("consultantAgreementName");
  const signature = sessionStorage.getItem("consultantAgreementSignature");

  if (!name || !signature) {
    $scope.checkboxes.accept3 = false;

    // Open the modal
    showAgreementPopup(); // Or $scope.showAgreementPopup() if you exposed it
  }
};

    
 function isCustomerLoggedIn() {
      // Check if ShopifyAnalytics and meta objects exist
      if (
        window.customerTags && Array.isArray(window.customerTags) && window.customerTags.includes("consultant")
      ) {
        return true;
      }
      return false;
    }

    function _handleShopifyCustomer() {
      if (isCustomerLoggedIn()) {
        const customerId = window.ShopifyAnalytics.meta.page.customerId;
        showLogoutPopup(customerId);
      }
    }

    _handleShopifyCustomer();
  },
]);
